import './elasticFixForNodeless'
import { Client } from '@elastic/elasticsearch'
import { createApiCallerProxy } from '../axios/createApiCallerProxy'
import { springCloudConfig } from '../spring-cloud-config/springCloudConfig'

export const elasticClient = createApiCallerProxy(createElasticClient)

function createElasticClient() {
  if (!isNodeRunning()) return {} as Client
  return new Client({
    node: springCloudConfig.getProp('URL_BASE_ELASTIC'),
    auth: getAuth(),
  })
}

function getAuth() {
  return {
    username: springCloudConfig.getProp('tcu.usuario-elastic'),
    password: springCloudConfig.getProp('tcu.senha-usuario-elastic'),
  }
}

function isNodeRunning() {
  return !!(process?.versions?.node) && process?.versions?.node !== '0.0.0'
}
